<!--
 * @Autor: lianxiben
 * @Date: 2023-04-15 14:52:20
 * @LastEditors: lianxiben
 * @LastEditTime: 2023-05-31 09:28:45
-->
<template>
  <div></div>
</template>
<script>
import { mapActions } from "vuex";
import { getTimeStamp } from "@/untils/utils";
export default {
  created() {
    this.isSetShare();
    this.isWeb();
  },
  methods: {
    isWeb() {
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (isMobile) {
        // User is on a mobile device
        this.$router.push({
          path: `/home${getTimeStamp()}`,
          query: {
            code: this.$route.query.code,
            invitation_code: this.$route.query.invitation_code,
            access_token: this.$route.query.access_token,
            company: this.$route.query.company,
          },
        });
      } else {
        this.$router.push({
          name: "pchome",
          query: {
            code: this.$route.query.code,
            invitation_code: this.$route.query.invitation_code,
            access_token: this.$route.query.access_token,
            company: this.$route.query.company,
          },
        });
      }
    },
    isSetShare() {
      const masterUrl = window.location.href;
      const domain = masterUrl.split("/")[2];
      this.setShare({
        link: `https://${domain}/appointment/enter${getTimeStamp()}?code=${localStorage.getItem(
          "code"
        )}&company=${localStorage.getItem("company")}`,
        title: "发自余杭客栈的飞鸽传书...",
        imgUrl: "https://download4.qcplay.com/xianjian/yuyue/wechat.png",
        desc: "李逍遥的邀请帖。仙剑记忆，问情再临！快来参与预热活动吧~ ",
      });
    },
    ...mapActions(["setShare"]),
  },
};
</script>
